import React, { useCallback, useMemo } from 'react';
import useUserPreferences from '../../../common/data/hooks/useUserPreferences';
import SitePreferencesForm from './SitePreferencesForm';
const SitePreferences = () => {
    const { me, preferences, updatePreferences } = useUserPreferences();
    const handlePreferenceEditSubmit = useCallback(async (values) => {
        const { timezone, weekStartsFrom } = values;
        await updatePreferences({
            TIME_ZONE: timezone,
            WEEK_STARTS_FROM: weekStartsFrom,
        });
    }, [updatePreferences]);
    const _entity = useMemo(() => ({
        id: me.id,
        timezone: preferences.TIME_ZONE,
        weekStartsFrom: preferences.WEEK_STARTS_FROM,
    }), [me.id, preferences]);
    return (<SitePreferencesForm entity={_entity} onSubmit={handlePreferenceEditSubmit}/>);
};
export default SitePreferences;
